import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { CMSTokenInterceptor } from './cms-token.interceptor';

@NgModule()
export class CommonCMSModule {
  static forRoot(): ModuleWithProviders<CommonCMSModule> {
    return {
      ngModule: CommonCMSModule,
      providers: [{ provide: HTTP_INTERCEPTORS, useClass: CMSTokenInterceptor, multi: true }],
    };
  }
}
